import { Checkbox } from '@mui/material'
import { allAvailableEventTypes } from 'src/consumer/constants'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'

export default function SessionOptionsCheckboxes({
  basicEventObject,
  setBasicEventObject,
  oneOnOnePlans,
  defaultSubscriptionPlanId,
  showNextVisitSlotSelectorEnabler,
  isDisabled,
}) {
  return (
    <>
      <GenericDisplayFlex>
        <div>Is the session free?</div>
        <Checkbox
          size="small"
          disabled={isDisabled}
          sx={{
            padding: 0,
            marginLeft: 1,
            '&.Mui-checked': {
              color: 'blue',
            },
          }}
          checked={basicEventObject?.free}
          onChange={(event) => {
            const { checked } = event.target
            setBasicEventObject((prev) => {
              if (checked) {
                return {
                  ...prev,
                  free: true,
                  subscriptionPlanId: '',
                  pricingPlanId: '',
                }
              }
              const isWebinar = prev?.type === allAvailableEventTypes.webinar
              const defaultPlanId = defaultSubscriptionPlanId || oneOnOnePlans?.[0]?.id
              return {
                ...prev,
                free: false,
                ...(isWebinar
                  ? {
                      pricingPlanId: defaultPlanId,
                      subscriptionPlanId: prev.subscriptionPlanId || defaultPlanId,
                    }
                  : {
                      subscriptionPlanId: defaultPlanId,
                      pricingPlanId: prev.pricingPlanId,
                    }),
              }
            })
          }}
        />
      </GenericDisplayFlex>

      <GenericDisplayFlex>
        <div>Is the session to be listed on AUMHUM Portal?</div>
        <Checkbox
          size="small"
          sx={{
            padding: 0,
            marginLeft: 1,
            '&.Mui-checked': {
              color: 'blue',
            },
          }}
          disabled={isDisabled}
          checked={basicEventObject?.publicEvent}
          onChange={(event) => {
            const { checked } = event.target
            setBasicEventObject((prev) => ({ ...prev, publicEvent: checked }))
          }}
        />
      </GenericDisplayFlex>

      {basicEventObject?.type === allAvailableEventTypes.consultation && (
        <>
          <GenericDisplayFlex>
            <div>Are Screeners Allowed to view prescriptions related to this consultation?</div>
            <Checkbox
              size="small"
              disabled={isDisabled}
              sx={{
                padding: 0,
                marginLeft: 1,
                '&.Mui-checked': {
                  color: 'blue',
                },
              }}
              checked={basicEventObject?.screenerAllowedToViewPrescription}
              onChange={(event) => {
                const { checked } = event.target
                setBasicEventObject((prev) => ({
                  ...prev,
                  screenerAllowedToViewPrescription: checked,
                }))
              }}
            />
          </GenericDisplayFlex>

          <GenericDisplayFlex>
            <div>Are Therapists allowed to view prescriptions related to this consultation?</div>
            <Checkbox
              size="small"
              disabled={isDisabled}
              sx={{
                padding: 0,
                marginLeft: 1,
                '&.Mui-checked': {
                  color: 'blue',
                },
              }}
              checked={basicEventObject?.therapistAllowedToViewPrescription}
              onChange={(event) => {
                const { checked } = event.target
                setBasicEventObject((prev) => ({
                  ...prev,
                  therapistAllowedToViewPrescription: checked,
                }))
              }}
            />
          </GenericDisplayFlex>
        </>
      )}

      {basicEventObject?.type === allAvailableEventTypes.therapySession &&
        showNextVisitSlotSelectorEnabler && (
          <GenericDisplayFlex>
            <div>Can the Therapist hold the next visit slot?</div>
            <Checkbox
              size="small"
              disabled={isDisabled}
              sx={{
                padding: 0,
                marginLeft: 1,
                '&.Mui-checked': {
                  color: 'blue',
                },
              }}
              checked={basicEventObject?.emrFormConfiguration?.allowGivingNextVisitDate}
              onChange={(event) => {
                const { checked } = event.target
                setBasicEventObject((prev) => ({
                  ...prev,
                  emrFormConfiguration: {
                    ...(prev?.emrFormConfiguration || {}),
                    allowGivingNextVisitDate: checked,
                  },
                }))
              }}
            />
          </GenericDisplayFlex>
        )}
    </>
  )
}
